import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 学习上下文
 * 为应用提供学习服务访问
 *
 * 核心功能：
 * 1. 提供学习服务的上下文
 * 2. 提供学习服务提供者组件
 * 3. 通过上下文机制向组件树提供学习功能
 */
import { createContext } from 'react';
import { LearningService } from '../services/learning.service.js';
/**
 * 创建学习上下文
 * 初始值为null，将在Provider中设置
 */
export const LearningContext = createContext(null);
/**
 * 学习服务提供者组件
 * 为组件树提供学习服务访问
 */
export const LearningProvider = ({ children }) => {
    // 获取学习服务单例
    const learningService = LearningService.getInstance();
    return _jsx(LearningContext.Provider, { value: learningService, children: children });
};
/**
 * 默认导出提供者组件
 * 便于导入使用
 */
export default LearningProvider;
//# sourceMappingURL=LearningContext.js.map